import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'secureUrl'
})
export class SecureUrlPipe implements PipeTransform {
  constructor(private dom:DomSanitizer)
  {

  }
  transform(value: any, args?: any): any {
    return this.dom.bypassSecurityTrustResourceUrl(value);
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/secure-url.pipe.ts